import { createReducer } from '@src/redux/helpers/createReducer';
import { VERIFY_MEDICAID } from './constants';

const initialState = {
  getVerifyMedicaidSaga: { isLoading: false, isError: false, isSuccess: false },
};

export const medicaidInfoReducer = createReducer(initialState, {
  [`${VERIFY_MEDICAID}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      getVerifyMedicaidSaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
  [`${VERIFY_MEDICAID}_STARTED`]: (state, action) => {
    return {
      ...state,
      getVerifyMedicaidSaga: {
        isLoading: true,
        isError: false,
        isSuccess: false,
      },
    };
  },
  [`${VERIFY_MEDICAID}_ERROR`]: (state, action) => {
    return {
      ...state,
      getVerifyMedicaidSaga: {
        isLoading: false,
        isError: true,
        isSuccess: false,
      },
    };
  },
});
